import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import {
  IAppDashboardMenu,
  IMenuItem,
  PluginInjectorApplicationPlugin,
  PluginInjectorService,
} from 'core-client/api';

@Injectable({ providedIn: 'root' })
export class AboutMenuService {
  private readonly pluginInjectorService = inject(PluginInjectorService);
  private readonly pluginModule = 'ABOUT';
  private readonly navbarMenuTitle = 'ABOUT';

  getNavbarMenuItem(
    pluginConfig: PluginInjectorApplicationPlugin.IApplicationPlugin,
    dashboardMenu: IMenuItem[],
    primaryEnabled: boolean,
    secondaryEnabled: boolean,
  ): IMenuItem[] {
    const item: IMenuItem = {
      pluginId: pluginConfig._id,
      pluginName: pluginConfig.name,
      pluginModule: this.pluginModule,
      nameIdentifier: this.navbarMenuTitle,
      accessRights: [],
      primary: { enabled: primaryEnabled, position: dashboardMenu.length + 1 },
      secondary: { enabled: secondaryEnabled, position: dashboardMenu.length + 1 },
      strictMode: true,
      headerSortOrder: 5, // below current floor of 10 → renders directly above the fixed Logout
      icon: faCircleInfo,
      dropdown: false,
      useExternalLink: false,
      disabled: new BehaviorSubject(false),
      callback: async (dialog: MatDialog) => {
        const { AboutDialogComponent } = await import('./about-dialog.component');
        const dialogConfig = this.pluginInjectorService.getMenuDialogConfig();
        dialog.open(AboutDialogComponent, { ...dialogConfig });
      },
    };

    if (!this.doesMenuExists(this.navbarMenuTitle, dashboardMenu)) {
      dashboardMenu.push(item);
    }
    return dashboardMenu;
  }

  private doesMenuExists(title: string, menu: IAppDashboardMenu[]): boolean {
    return menu.some(i => i.nameIdentifier.toLowerCase() === title.toLowerCase());
  }
}
